import { render, staticRenderFns } from "./EditarNomeAdministradorUnidade.vue?vue&type=template&id=3bc30567"
import script from "./EditarNomeAdministradorUnidade.vue?vue&type=script&lang=js"
export * from "./EditarNomeAdministradorUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports